const capitalizeFirstLetter = (inputString: string): string =>
  inputString.charAt(0).toUpperCase() + inputString.slice(1).toLowerCase();

export { capitalizeFirstLetter };
